import ContentLoader from 'react-content-loader';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'store/hook';

const MessangerLoader = (props: any) => {
  const { isDarkMode } = useAppSelector((state) => state.windowState);
  
  const { t } = useTranslation();

  return (
    <div style={{ borderRadius: 0, margin: '0', width: '100%', height: '100%' }}>
      <ContentLoader
        speed={2}
        width='100%'
        title={t('Documents.table.loader')}
        height='100%'
        backgroundColor={isDarkMode ? '#303030ff' : '#f5f6f7'}
        foregroundColor={isDarkMode ? '#101010ff' : '#eee'}
        {...props}
      >
        <rect x='0' y='0' rx='0' ry='0' width='100%' height='900' />
      </ContentLoader>
    </div>
  );
};
export default MessangerLoader;
